import {
  GET_INVOICES_FAIL,
  GET_INVOICES_FETCHING,
  GET_INVOICES_SUCCESS
} from '../actions/invoicesActions';

const initialState = {
  invoices: [],
  loading: false,
  errors: '',
  totalRecords: 0
};


const invoicesReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_INVOICES_FETCHING:
      return { ...state, loading: true };
    case GET_INVOICES_FAIL:
      return { ...state, loading: false, errors: action.payload.message };
    case GET_INVOICES_SUCCESS:
      return { ...state, invoices: action.payload.invoices.invoices, totalRecords: Number(action.payload.invoices.total_records), loading: false, errors: '' };
    default:
      return state;
  }
};

export default invoicesReducer;
